import React from 'react';
import superagent from 'superagent';
import ReactDOM from 'react-dom';

import { LoggedUserAdmin, LoggedUserId } from '../login/Login';

import styles from '../kalendar/Home.css';

export default class UsersEditModal extends React.Component {

  constructor() {
    super();
    this.state = {
      lekce: null,
      chckedAktivni: null,
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleChangeLekce = this.handleChangeLekce.bind(this);
    this.handleChangeAktivni = this.handleChangeAktivni.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({lekce: nextProps.editModal.lekce, chckedAktivni: (nextProps.editModal.aktivni == 'A')});
  }

  handleChangeLekce(event) {
    this.setState({lekce: event.target.value});
  }

  handleChangeAktivni() {
    this.setState({chckedAktivni: !this.state.chckedAktivni});
  }

  handleSave(event) {
    event.preventDefault();

    if (ReactDOM.findDOMNode(this.refs.inputAktivni).checked) { var aktivni = 'A' } else { var aktivni = 'N' }

    superagent.post('https://rezervace.copasedeje.cz/servis/_user_edit.php?').
      send('adminID=' + LoggedUserId()).
      send("userID="+this.props.editModal.userID).
      send("lekce="+ReactDOM.findDOMNode(this.refs.inputLekce).value).
      send("aktivni="+aktivni).
      then(res => {
        var myObject = JSON.parse(res.text);
        this.props.setUserList(myObject);
      });

    return false;
  }

  render() {
    if (this.props.editModal == null)
      return null;

    return (
      <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header d-block">
              <h5 className="modal-title d-flex text-danger" id="exampleModalLabel">
                {this.props.editModal.jmeno}
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </h5>
              <div className="">({this.props.editModal.email})</div>
            </div>
            <div className="modal-body">
              <div className="form-group row">
                <label htmlFor="inputLekce" className="col-sm-4 col-5 col-form-label text-right">Zaplacené lekce:</label>
                <div className="col-4">
                  <input type="text" className="form-control text-center" ref="inputLekce" id="inputLekce" value={this.state.lekce} onChange={this.handleChangeLekce} />
                </div>
              </div>
              <div className="form-group row">
                  <label className="form-check-label col-sm-4 col-5 text-right " htmlFor="inputAktivni">
                  Aktivovaný uživatel:
                </label>
                <div className="col-2">
                  <input className="" type="checkbox" checked={this.state.chckedAktivni} ref="inputAktivni" id="inputAktivni" onChange={this.handleChangeAktivni} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Zavřít</button>
              <button type="button" className="btn btn-success" data-dismiss="modal" onClick={this.handleSave}>Uložit</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// src/components/users/UsersEditModal.js